import { StudentProblemResult } from '@yandex-int/k-common';
import { getCriteria } from '@yandex-int/k-common/client/api/defs/get-criteria';
import React from 'react';
import { useQuery } from 'react-query';

import { LessonProblemWithResult } from 'common.components/student-lesson-stat/typings';
import { getOpenAnswerAttemptId } from 'utils/open-answer';

import { LessonContentCriteria } from './lesson-content__criteria';

interface Props {
    problemLink: LessonProblemWithResult;
    studentProblemResult: StudentProblemResult | null;
    studentId: number | null | undefined;
}

const LessonContentCriteriaContainerMemo = ({ problemLink, studentProblemResult, studentId }: Props) => {
    const criteria = useQuery(['getCriteria', problemLink.problem.id], () => getCriteria(problemLink.problem.id));

    if (!(criteria.data && criteria.data.length > 0)) {
        // критериев нет для этой задачи (или не загрузились)
        return null;
    }

    return (
        <LessonContentCriteria
            attemptId={getOpenAnswerAttemptId(studentProblemResult, problemLink.id, studentId)}
            criteriaData={criteria.data}
            problemId={problemLink.problem.id}
        />
    );
};

export const LessonContentCriteriaContainer = React.memo(LessonContentCriteriaContainerMemo);
